import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Membro } from 'src/app/modules/_models/membro';
import { VoucherPalito } from 'src/app/modules/_models/voucherPalito.interface';
import { AuthService } from 'src/app/modules/_services/auth.service';
import { FidelidadeService } from 'src/app/modules/_services/fidelidade.service';
import { TratamentoMensagensService } from 'src/app/modules/_services/tratamento-mensagens.service';

@Component({
  selector: 'app-voucher',
  templateUrl: './voucher.component.html',
  styleUrls: ['./voucher.component.scss'],
})
export class VoucherComponent implements OnInit {
  constructor(
    private fidelidadeService: FidelidadeService,
    private authService: AuthService,
    private router: Router,
    private tratamentoMensagensService: TratamentoMensagensService
  ) { }
  public voucherModal = false;
  public voucherJaUtilizado = false;
  public carregandoVoucher = false;
  public voucherInvalido = false;
  public voucherNaoEncontrado = false;
  public voucher = '';
  public exibirPopupResgateCacaus: boolean = false;
  public exibirPopupResgatePontos: boolean = false;
  public exibirPopupResgatePromocao: boolean = false;
  public exibirPopupResgateExperiencia: boolean = false;
  public exibirModalRegulamento: boolean = false;
  public pontos: number = 0;
  public cacaus: number = 0;
  public promocao: number = 0;
  public experiencia: number = 0;
  public quantidadePromocoesUsuarios: number = null;
  public promocaoModel: any = null;
  public experienciaModel: any = null;
  private mostrarBotao: boolean = false;
  public voucherNaoConsumido: boolean = false;
  public resgateFeito: boolean = false;
  public regulamento: string[] = [];
  public errorVoucher = '';
  public voucherLinkeMess: VoucherPalito;

  // Membro
  public membro: Membro | undefined;

  ngOnInit(): void {
    this.authService.LocalStorage.currentUserMembro.subscribe((membro) => {
      this.membro = membro;
    });
  }

  buscaVoucher() {
    if (this.voucher) {
      const voucher = {
        codigo: this.voucher,
      };
      this.carregandoVoucher = true;
      this.fidelidadeService.consultarVoucher(voucher).subscribe({
        next: (res: VoucherPalito) => {
          this.processarSucessoObterConsultarVoucher(res);
        },
        error: (err: any) => {
          this.carregandoVoucher = false;
          if (err.mensagensErro[0].includes('Não existe voucher'))
            this.errorVoucher =
              'Não existe voucher cadastrado com o código informado!';
        },
      });
    }
  }

  private processarSucessoObterConsultarVoucher(res: VoucherPalito) {
    this.errorVoucher = '';
    this.voucherLinkeMess = res;

    if (res.qtd < 1) {
      this.voucherJaUtilizado = true;
      this.carregandoVoucher = false;
      this.errorVoucher = 'Voucher indisponivel!';
      return;
    }

    let cacaus = res.pontos;

    let pontos = res.pontosXP;

    let promocao = res.idPromocao;

    let quantidadePromocoesUsuarios = res.quantidadePromocoesUsuarios;

    let experiencia = res.idExperiencia;

    let voucher = {
      codigo: res.codigo,
      idMembro: this.membro.id,
    };

    this.fidelidadeService.consumirVoucher(voucher).subscribe({
      next: (res: any) => {
        this.resgateFeito = true;
        if (cacaus > 0) {
          this.cacaus = cacaus;
          this.exibirPopupResgateCacaus = true;
          this.fidelidadeService.obterMembro().subscribe({
            next: (res: any) => {
              this.authService.LocalStorage.salvarMembro(res);
            },
            error: (err: any) => {
              console.log(err);
              this.errorVoucher =
                this.tratamentoMensagensService.tratarMensagem(
                  err.mensagensErro[0]
                );
            },
            complete: () => {
              this.carregandoVoucher = false;
            },
          });
        }
        if (pontos > 0) {
          this.pontos = pontos;
          this.exibirPopupResgatePontos = true;
          this.fidelidadeService.obterMembro().subscribe({
            next: (res: any) => {
              this.authService.LocalStorage.salvarMembro(res);
            },
            error: (err: any) => {
              console.log(err);
              this.errorVoucher =
                this.tratamentoMensagensService.tratarMensagem(
                  err.mensagensErro[0]
                );
            },
            complete: () => {
              this.carregandoVoucher = false;
            },
          });
        }

        if (promocao !== null) {
          this.promocao = promocao;
          this.quantidadePromocoesUsuarios = quantidadePromocoesUsuarios;
          this.fidelidadeService.obterPromocaoPorId(promocao).subscribe({
            next: (res: any) => {
              this.promocaoModel = res;
              this.exibirPopupResgatePromocao = true;
            },
            error: (err: any) => {
              console.log(err);
              this.errorVoucher =
                this.tratamentoMensagensService.tratarMensagem(
                  err.mensagensErro[0]
                );
            },
            complete: () => {
              this.carregandoVoucher = false;
            },
          });
        }

        if (experiencia !== null) {
          this.experiencia = experiencia;

          if (this.voucherLinkeMess.mensagemResgate) {
            this.exibirPopupResgateExperiencia = true;
          } else {
            this.fidelidadeService.obterExperiencia(experiencia).subscribe({
              next: (res: any) => {
                this.experienciaModel = res.resultado;
                this.exibirPopupResgateExperiencia = true;
              },
              error: (err: any) => {
                console.log(err);
                this.errorVoucher =
                  this.tratamentoMensagensService.tratarMensagem(
                    err.mensagensErro[0]
                  );
              },
              complete: () => {
                this.carregandoVoucher = false;
              },
            });
          }
        }
        this.voucher = '';
      },
      error: (err: any) => {
        if (err.mensagensErro[0].includes('Membro já resgatou o voucher!')) {
          this.errorVoucher = 'Membro já resgatou o voucher!';
        }
        this.voucherNaoConsumido = true;
        this.carregandoVoucher = false;
        this.errorVoucher = this.tratamentoMensagensService.tratarMensagem(
          err.mensagensErro[0]
        );
      },
    });
  }

  public irParaMeusMomentos(): void {
    this.voucherModal = false;
    this.exibirPopupResgatePromocao = false;
    this.exibirPopupResgateExperiencia = false;
    this.router.navigate(['/minhas-experiencias']);
  }

  public irParaMomentosEspeciais(): void {
    this.voucherModal = false;
    this.exibirPopupResgateCacaus = false;
    this.exibirPopupResgatePontos = false;
    const resgate = this.voucherLinkeMess.link ?? '/momentos-especiais';
    this.router.navigate([resgate]);
  }

  openVoucher() {
    this.voucherModal = true;
  }
}
